import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Wallet = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M8.88889 7.49992H16.1111V14.4444C16.1111 15.2116 15.4894 15.8333 14.7222 15.8333H5.27777C4.51055 15.8333 3.88889 15.2116 3.88889 14.4444V5.83325" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M16.1111 7.49996H5.55555C4.635 7.49996 3.88889 6.75385 3.88889 5.83329C3.88889 4.91274 4.635 4.16663 5.55555 4.16663H13.8889" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default Wallet;